import {
  $validateProduct,
  $repairCaratech,
  $getAllTopRefs,
  $repairColor,
} from "../requests"
import { DropitState, getUserRole } from "../reducers"

interface IProductToRepair {
  rowId: string
  supplierCode: string
}

export const repairTopRefs =
  () => (dispatch: (callback: object) => void, getState: () => DropitState) => {
    const role = getUserRole(getState())

    $getAllTopRefs().then((res: IProductToRepair[]) => {
      res.forEach((r) => $validateProduct(r.rowId, role, null, r.supplierCode))
    })
  }
export const repairCaratech =
  () => (dispatch: (callback: object) => void, getState: () => DropitState) => {
    const role = getUserRole(getState())

    $repairCaratech().then((res: IProductToRepair[]) => {
      res.forEach((r) => $validateProduct(r.rowId, role, null, r.supplierCode))
    })
  }

export const repairColor =
  () => (dispatch: (callback: object) => void, getState: () => DropitState) => {
    const role = getUserRole(getState())

    $repairColor().then((res: IProductToRepair[]) => {
      res.forEach((r) => $validateProduct(r.rowId, role, null, r.supplierCode))
    })
  }
